/** Projecting fungi attach only to a catalog host's proven painted region.
 * The small mycelium patch needs wall contact; the shelves project into air. */
export const CAVERN_FIXTURE_TEMPLATES = {
  shelf_fungus: { kind: 'bioluminescent_fungus', name: 'Layered bracket fungus', frame: { w: 64, h: 44 },
    band: 'architecture', fixture: true, attachment: 'wall',
    mountPatch: { x: 3, y: 12, width: 6, height: 18 } },
} as const;
